import React from 'react';
import { PropTypes } from 'prop-types';
import classnames from 'classnames';

import styles from './Button.css';

const Button = ({
  disabled,
  onClick,
  btnText,
  className,
  submitting,
  ...rest
}) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className={classnames(
      className || styles.buttonDefault,
      styles.buttonCommon,
      submitting ? styles.loading : ''
    )}
    {...rest}
  >
    {btnText}
  </button>
);

Button.propTypes = {
  disabled: PropTypes.bool,
  btnText: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  submitting: PropTypes.bool,
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.jsx